<template>
  <with-actions>
    <template v-if="product">
      <div class="row">
        <div class="col-md-2 text-right">
          <h6 class="underline">{{ 'details' | t | titlecase }}</h6>
        </div>
        <div class="col-md-8">
          <div class="card card-body">
            <div class="form-group">
              <label class="mb-0">{{ 'product_type' | t }}</label>
              <select class="form-control" v-model="product.product_type">
                <option v-for="product_type in product_types" :value="product_type">{{ product_type | t }}</option>
              </select>
            </div>
            <div class="form-group">
              <label class="mb-0">{{ 'billing_product_id' | t }}</label>
              <input class="form-control" v-model="product.billing_product_id" />
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-2 text-right">
          <h6 class="underline">{{ 'descriptions' | t | titlecase }}</h6>
        </div>
        <div class="col-md-8">
          <div class="card" v-if="product.descriptions.length == 0">
            <div class="card-body">
              <p>
                <span>{{ 'no_descriptions' | t }}</span>
              </p>
            </div>
          </div>
          <div class="card mb-2" v-for="(description, i) in product.descriptions">
            <div class="card-body">
              <div class="row mb-3 align-items-end">
                <div class="col-6">
                  <label>Locale</label>
                  <select class="form-control" v-model="description.locale">
                    <option v-for="locale in locales" :value="locale">{{ locale }}</option>
                  </select>
                </div>
                <div class="col-auto ml-auto">
                  <button class="btn btn-outline-danger" @click="product.descriptions.splice(i, 1)">
                    Remove description
                  </button>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col">
                  <label>Title</label>
                  <input class="form-control" v-model="description.title" />
                </div>
                <div class="col">
                  <label>Description</label>
                  <input class="form-control" v-model="description.description" />
                </div>
              </div>
            </div>
          </div>
          <br />
          <button class="btn btn-primary" @click="add_description">Add description</button><br />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-2 text-right">
          <h6 class="underline">{{ 'prices' | t | titlecase }}</h6>
        </div>
        <div class="col-md-8">
          <div class="card" v-if="product.prices.length == 0">
            <div class="card-body">
              <p>
                <span>{{ 'no_prices' | t }}</span>
              </p>
            </div>
          </div>
          <div class="card mb-2" v-for="(price, i) in product.prices">
            <div class="card-body">
              <div class="row mb-3 align-items-end">
                <div class="col">
                  <label>Price</label>
                  <input class="form-control" v-model="price.price" />
                </div>
                <div class="col">
                  <label>Currency</label>
                  <select class="form-control" v-model="price.currency">
                    <option v-for="currency in currencies" :value="currency">{{ currency }}</option>
                  </select>
                </div>
                <div class="col-auto">
                  <button class="btn btn-outline-danger" @click="product.prices.splice(i, 1)">Remove price</button>
                </div>
              </div>
            </div>
          </div>
          <br />
          <button class="btn btn-primary" @click="add_price">Add price</button><br />
        </div>
      </div>
      <div class="row text-right">
        <div class="col-12">
          <hr />
        </div>
        <div class="col-12">
          <button class="btn btn-success" @click="save">{{ id ? 'update' : 'create' | t }}</button>
        </div>
      </div>
    </template>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
import config from '@/config';
import _ from 'lodash';

export default {
  props: ['product_id'],
  data: function () {
    return {
      product: null,
      id: this.product_id,
      product_types: ['service', 'product'],
      currencies: ['DKK', 'EUR'],
      locales: ['en', 'da']
    };
  },
  computed: {},
  methods: {
    add_price() {
      this.product.prices.push({ price: 0, currency: this.currencies[0] });
    },
    add_description() {
      this.product.descriptions.push({
        title: '',
        description: '',
        locale: this.locales[0]
      });
    },
    save() {
      if (this.product_id) {
        Api.update('products', this.product)
          .then(({ data }) => {
            Alerts.success({ title: 'product was updated', detail: '' });
            this.$router.push({ name: 'products' });
          })
          .catch((errors) => {
            _.forEach(errors, (error) => {
              Alerts.danger(error[0]);
            });
          });
      } else {
        Api.create('products', this.product)
          .then(({ data }) => {
            Alerts.success({ title: 'product was created', detail: '' });
            this.$router.push({ name: 'products' });
          })
          .catch((errors) => {
            _.forEach(errors, (error) => {
              Alerts.danger(error[0]);
            });
          });
      }
    }
  },
  mounted: function () {
    this.setBreadcrumbs([{ to: { name: 'products' }, text: 'product' }]);
    if (this.product_id) {
      Api.find('products', this.product_id).then(({ data }) => {
        this.product = data;
      });
    } else {
      this.product = {
        billing_product_id: null,
        product_type: this.product_types[0],
        descriptions: [],
        prices: []
      };
    }
  }
};
</script>

<style scoped></style>
